// extracted by mini-css-extract-plugin
export default {"container":"title-page_container__wbIRq","title":"title-page_title__lOAxm"};